import { createQueryKeys } from '@lukemorales/query-key-factory'

export const auth = createQueryKeys('auth', {
  // Queries
  session: null,
  verifyUsername: (username: string) => ({
    queryKey: [{ username }],
  }),
  verifyPassword: (password: string) => ({
    queryKey: [{ password }],
  }),

  // Mutations
  signIn: null,
  signUp: null,
  signOut: null,
  confirmSignUp: null,
  resendConfirmationCode: null,
  requestPasswordReset: null,
  confirmPasswordReset: null,
  updatePassword: null,
})
